import Vue from 'vue'
import Vuex from 'vuex'
import setting from './modules/setting'
import modal from './modules/modal'
import scheduledRecommend from './modules/scheduledRecommend'
import seat from './modules/seat'
import menu from './modules/menu'
import search from './modules/search'
import error from './modules/error'
import auth from './modules/auth'
import reservation from './modules/reservation'
import selfcheck from './modules/selfcheck'
import shopDetail from './modules/shopDetail'

Vue.use(Vuex)

export const storeConfig = {
  modules: {
    setting,
    modal,
    scheduledRecommend,
    seat,
    menu,
    search,
    reservation,
    selfcheck,
    shopDetail,
    error,
    auth,
  },
}

export default new Vuex.Store(storeConfig)
